module.exports = __webpack_public_path__ + "img/account_results.bbc9d071.svg";